export default "__VITE_ASSET__dd4dc9b2__"